<template>
  <div>
    <!--  注文製品選択画面 -->
    <t-card v-loading="loading">
      <!-- 注文製品情報 -->
      <div :style="{ height: basicHeight + 'px', 'padding-top': '10px' }">
        <!-- UPD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 start↓ -->
        <!-- 課題_納期分割機能の追加 -->
        <!-- <t-form
          :model="receInfoEditForm"
          label-position="right"
          label-width="70px"
        > -->
        <t-form
          :model="receInfoEditForm"
          label-position="right"
          label-width="90px"
        >
          <!-- UPD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 end↑ -->
          <t-row class="col_common_center">
            <!-- 仕入先 -->
            <!-- UPD 2025/06/13 ZLL 課題_250610顧客からの改善したい点への対応 start↓ -->
            <!-- 課題_打合状態、納期の追加 -->
            <!-- <t-col :span="5"> -->
            <t-col :span="2">&nbsp;</t-col>
            <t-col :span="6">
              <!-- UPD 2025/06/13 ZLL 課題_250610顧客からの改善したい点への対応 end↑ -->
              <!-- UPD 2025/12/08 ZLL 課題_251208顧客からの改善したい点への対応 start↓ -->
              <!-- <t-form-item
                :label="$t('resource.orderInfo.supplierCpy')"
                class="marginBottom"
              >
                <t-input
                  v-model="receInfoEditForm.crbSupInfo"
                  class="commonDialog"
                  disabled
                >
                </t-input>
              </t-form-item> -->

              <t-form-item
                :label="$t('resource.checkReceInfo.crbSupInfo')"
                class="marginBottom"
              >
                <t-select
                  placeholder=""
                  class="commonDialog"
                  v-model="receInfoEditForm.crbSupCode"
                >
                  <t-option
                    v-for="item in supplierList"
                    :key="item.supCode"
                    :label="item.supCode + ':' + item.supAbbreviation"
                    :value="item.supCode"
                  >
                  </t-option>
                </t-select>
              </t-form-item>
              <!-- UPD 2025/12/08 ZLL 課題_251208顧客からの改善したい点への対応 end↑ -->
            </t-col>
            <!-- 注文No -->
            <!-- UPD 2025/06/13 ZLL 課題_250610顧客からの改善したい点への対応 start↓ -->
            <!-- 課題_打合状態、納期の追加 -->
            <!-- <t-col :span="5"> -->
            <t-col :span="1">&nbsp;</t-col>
            <t-col :span="6">
              <!-- UPD 2025/06/13 ZLL 課題_250610顧客からの改善したい点への対応 end↑ -->
              <t-form-item
                :label="$t('resource.checkReceInfo.crdOrderNo')"
                class="marginBottom"
              >
                <t-input
                  v-model="receInfoEditForm.orderNo"
                  maxLength="25"
                  clearable
                  class="commonDialog"
                >
                </t-input>
              </t-form-item>
            </t-col>

            <!-- 図番 -->
            <!-- UPD 2025/06/13 ZLL 課題_250610顧客からの改善したい点への対応 start↓ -->
            <!-- 課題_打合状態、納期の追加 -->
            <!-- <t-col :span="5"> -->
            <t-col :span="1">&nbsp;</t-col>
            <t-col :span="6">
              <!-- UPD 2025/06/13 ZLL 課題_250610顧客からの改善したい点への対応 end↑ -->
              <t-form-item
                :label="$t('resource.checkReceInfo.crdPictureNo')"
                class="marginBottom"
              >
                <t-input
                  v-model="receInfoEditForm.aodProdDrawNo"
                  clearable
                  maxLength="30"
                  class="commonDialog"
                >
                </t-input>
              </t-form-item>
            </t-col>
            <!-- ADD 2025/06/13 ZLL 課題_250610顧客からの改善したい点への対応 start↓ -->
            <!-- 課題_打合状態、納期の追加 -->
            <t-col :span="2">&nbsp;</t-col>
          </t-row>
          <t-row class="col_common_center">
            <t-col :span="2">&nbsp;</t-col>
            <!-- ADD 2025/06/13 ZLL 課題_250610顧客からの改善したい点への対応 end↑ -->
            <t-col :span="10">
              <!-- UPD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 start↓ -->
              <!-- 手配日→仕入先納期を変更 -->
              <!-- <t-form-item :label="$t('resource.checkReceInfo.crdOrderDate')"> -->
              <t-form-item
                :label="$t('resource.checkReceInfo.SUPPLIER_DUE_DATE')"
              >
                <!-- UPD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 end↑ -->
                <t-date-picker
                  v-model="receInfoEditForm.quoteDateRange"
                  type="daterange"
                  :clearable="true"
                  class="date_icon_center"
                  range-separator="～"
                  :editable="false"
                  start-placeholder="開始日"
                  end-placeholder="終了日"
                  value-format="yyyy/MM/dd"
                  format="yyyy/MM/dd"
                  style="width: 90%"
                >
                </t-date-picker>
              </t-form-item>
            </t-col>
            <!-- ADD 2025/06/13 ZLL 課題_250610顧客からの改善したい点への対応 start↓ -->
            <!-- 課題_打合状態、納期の追加 -->
            <t-col :span="4">&nbsp;</t-col>
            <t-col :span="3" class="center">
              <template>
                <!-- 打合中有 -->
                <t-checkbox
                  v-model="discussingFlg"
                  :label="$t('resource.PREPARE_TRANS.FLG_DISCUSSING_EXIST')"
                  style="line-height: 3.5; margin-right: 40px"
                />
              </template>
            </t-col>
            <!-- ADD 2025/06/13 ZLL 課題_250610顧客からの改善したい点への対応 end↑ -->

            <t-col :span="3" class="right">
              <!-- 検索 -->
              <t-button
                round
                type="primary"
                class="dialogButton_120_40"
                style="margin-top: 0"
                ref="searchBtn"
                @click="searchClick()"
              >
                <i class="el-icon-search"></i>
                {{ $t("resource.sys.search") }}
              </t-button>
            </t-col>
            <!-- ADD 2025/06/13 ZLL 課題_250610顧客からの改善したい点への対応 start↓ -->
            <t-col :span="2">&nbsp;</t-col>
            <!-- ADD 2025/06/13 ZLL 課題_250610顧客からの改善したい点への対応 end↑ -->
          </t-row>
        </t-form>
      </div>

      <div>
        <t-row class="marginBottom">
          <t-col
            :span="parseInt($t('widgetSize.ReceOrderSelectDialog.colOneSpan'))"
          >
            <!-- テーブル -->
            <div>
              <t-table
                ref="orderProductForm"
                :data="orderProductForm"
                class="table_common"
                header-cell-class-name="bg-default"
                :height="detailHeight"
                highlight-current-row
                :row-class-name="rowClassName"
                @selection-change="handleRowClick"
                border
                fit
              >
                <!-- 選択ボックス -->
                <t-table-column
                  prop="selected"
                  type="selection"
                  :selectable="selectableCheck"
                  class-name="cell_txt_center"
                />

                <!-- テーブルの列 -->
                <t-table-column
                  v-for="(column, index) in columns"
                  :key="index"
                  :type="column.type"
                  :prop="column.prop"
                  :label="column.label"
                  :min-width="column.width"
                  :align="column.align"
                  :header-align="column.headerAlign"
                  :class-name="column.class"
                  :show-overflow-tooltip="column.overflowTooltip"
                >
                </t-table-column>

                <!-- ADD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓ -->
                <!-- 課題_備考機能の追加 -->
                <!-- UPD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 start↓ -->
                <!-- 共通備考の調整 -->
                <!-- <t-table-column
                  :label="$t('resource.REMARKS_ADD.REMARKS')"
                  class="cell_txt_center"
                  :min-width="100"
                >
                  <template slot-scope="scope">
                    <div class="button-container">
                      <t-tooltip placement="bottom" effect="light">
                        <div
                          slot="content"
                          class="tooltip-content"
                          v-html="
                            formatRemarksShowProc(scope.row.aodProdRemarksSum)
                          "
                        ></div>
                        <t-button
                          :type="getIconTypeProc(scope.row.aodProdRemarksSum)"
                          icon="el-icon-search"
                          size="small"
                          circle
                        >
                        </t-button
                      ></t-tooltip>
                    </div>
                  </template>
                </t-table-column> -->
                <t-table-column
                  :label="$t('resource.REMARKS_ADD.REMARKS')"
                  prop="aodProdRemarksSum"
                  :class-name="'cell_txt_center'"
                  :width="getRemarksColumnWidthProc()"
                  :show-overflow-tooltip="true"
                >
                  <template slot-scope="scope">
                    <div class="bikouDiv">
                      <!-- 備考表示 -->
                      <span class="bikouText">
                        {{ scope.row.aodProdRemarksSum }}
                      </span>
                    </div>
                  </template>
                </t-table-column>
                <!-- UPD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 end↑ -->
                <!-- ADD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑ -->
              </t-table>
            </div>
          </t-col>
        </t-row>
      </div>
      <div :style="{ height: bottomHeight + 'px' }">
        <t-row type="flex" justify="end">
          <div>
            <t-col :span="24">
              <t-button
                round
                type="warning"
                class="dialogButton_confirm_120_40"
                ref="confirmBtn"
                @click="confirmClick"
              >
                <i class="el-icon-check"></i>
                {{ $t("resource.sys.sure") }}</t-button
              >
            </t-col>
          </div>
        </t-row>
      </div>
    </t-card>
  </div>
</template>
<script>
import { t } from "@/locales";
import { getReceOrderSelectInfo } from "@/services/checkReceInfo";
import {
  formatDateToString,
  formatRemarksShow,
  formatStringToCurrency,
  formatStringToDate,
  getDialogContentHeight,
  getEditColWidthArr,
  getIconType,
  getNextMonthDate,
  getRemarksColumnWidth,
  ShowMergeExKbn,
} from "@/utils/comFunction";
import { DIALOG_LINE_HEIGHT, FINAL_STR, STR_ONE } from "@/utils/const";
import { flexColumnWidth, setColumnWidth } from "@/utils/table";
import { Message, Modal } from "@tellus/component";
export default {
  data() {
    return {
      receInfoEditForm: {
        // 注文日→仕入先納期
        quoteDateRange: "",
        // 注文日開始日→仕入先納期開始日
        startDate: "",
        // 注文日終了日→仕入先納期終了日
        endDate: "",
        // 注文No
        orderNo: "",
        // 見積No
        quoteNo: "",
        // 仕入先Code
        crbSupCode: "",
        // 仕入先Code: 仕入先名
        crbSupInfo: "",
        // 図番
        aodProdDrawNo: "",

        // ADD 2025/06/13 ZLL 課題_250610顧客からの改善したい点への対応 start↓
        // 課題_打合状態、納期の追加
        searchDiscussingFlg: "", //打合中有
        // ADD 2025/06/13 ZLL 課題_250610顧客からの改善したい点への対応 end↑
      },

      // ADD 2025/06/13 ZLL 課題_250610顧客からの改善したい点への対応 start↓
      // 課題_打合状態、納期の追加
      discussingFlg: false,
      // ADD 2025/06/13 ZLL 課題_250610顧客からの改善したい点への対応 end↑

      // ADD 2025/12/08 ZLL 課題_251208顧客からの改善したい点への対応 start↓
      // 仕入先リスト
      supplierList: this.SupplierList,
      // ADD 2025/12/08 ZLL 課題_251208顧客からの改善したい点への対応 end↑

      //基本情報のheight
      // UPD 2025/06/13 ZLL 課題_250610顧客からの改善したい点への対応 start↓
      // 課題_検査室入荷日の追加
      // basicHeight: DIALOG_LINE_HEIGHT * 1,
      basicHeight: DIALOG_LINE_HEIGHT * 2,
      // UPD 2025/06/13 ZLL 課題_250610顧客からの改善したい点への対応 end↑

      //明細情報のheight 20:Tableと合計行の間隔調整用(Table的marginTop + bottom)
      // UPD 2025/06/13 ZLL 課題_250610顧客からの改善したい点への対応 start↓
      // 課題_検査室入荷日の追加
      // detailHeight: getDialogContentHeight(
      //   window.innerHeight,
      //   DIALOG_LINE_HEIGHT * 1,
      //   DIALOG_LINE_HEIGHT * 1,
      //   30
      // ),
      detailHeight: getDialogContentHeight(
        window.innerHeight,
        DIALOG_LINE_HEIGHT * 2,
        DIALOG_LINE_HEIGHT * 1,
        35
      ),
      // UPD 2025/06/13 ZLL 課題_250610顧客からの改善したい点への対応 end↑

      //合計情報のheight
      bottomHeight: DIALOG_LINE_HEIGHT * 1,

      //列の幅
      colArr: getEditColWidthArr(window.innerWidth, 6),

      // 待つ
      loading: true,

      //受注一覧選択情報
      orderProductForm: [],
      //仕入先見積依頼のテーブルの列
      columns: [
        // ADD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 start↓
        // 課題_納期分割機能の追加
        {
          // 仕入先納期列
          prop: "odDueDate",
          label: t("resource.checkReceInfo.SUPPLIER_DUE_DATE"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_center",
          overflowTooltip: true,
        },
        // ADD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 end↑
        // 注文日
        {
          prop: "obDate",
          label: t("resource.checkReceInfo.crdOrderDate"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_center",
          overflowTooltip: false,
        },
        {
          // 注文No
          prop: "crdOrderNoShow",
          label: t("resource.checkReceInfo.crdOrderNo"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_left",
          overflowTooltip: false,
        },
        // 品名
        {
          prop: "aodProdName",
          label: t("resource.checkReceInfo.crdProductName"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_left",
          overflowTooltip: true,
        },
        // 図番
        {
          prop: "aodProdDrawNo",
          label: t("resource.checkReceInfo.crdPictureNo"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_left",
          overflowTooltip: true,
        },
        // 注文数
        {
          prop: "odProdQuantity",
          label: t("resource.checkReceInfo.crdCount"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_right",
          overflowTooltip: true,
        },

        // 注文クローズ数
        // {
        //   prop: "odProdCloseQty",
        //   label: t("resource.checkReceInfo.crdCloseCount"),
        //   width: t("widgetSize.tableCommon.defaultWidth"),
        //   class: "cell_txt_right",
        //   overflowTooltip: false,
        // },

        // 単位
        {
          prop: "aodProdUnit",
          label: t("resource.checkReceInfo.crdUnit"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_center",
          overflowTooltip: true,
        },

        // DEL 2025/03/19 ZLL 課題_形状、素材、処理を削除したい start↓
        // 素材
        // {
        //   prop: "aodProdMaterial",
        //   label: t("resource.checkReceInfo.crdMaterial"),
        //   width: t("widgetSize.tableCommon.defaultWidth"),
        //   class: "cell_txt_left",
        //   overflowTooltip: true,
        // },
        // // 処理
        // {
        //   prop: "aodProdTreatment",
        //   label: t("resource.checkReceInfo.crdTreatment"),
        //   width: t("widgetSize.tableCommon.defaultWidth"),
        //   class: "cell_txt_left",
        //   overflowTooltip: true,
        // },
        // DEL 2025/03/19 ZLL 課題_形状、素材、処理を削除したい end↑
        // 加工単価(CNY)
        // {
        //   prop: "odUPrice",
        //   label: t("resource.checkReceInfo.crdProcessUnit"),
        //   width: t("widgetSize.tableCommon.defaultWidth"),
        //   class: "cell_txt_right",
        //   overflowTooltip: true,
        // },

        // ADD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 start↓
        // 打合状態
        {
          prop: "aodDiscussStatus",
          label: t("resource.checkReceInfo.PROD_DISCUSS_STATUS"),
          width: t("widgetSize.tableCommon.width80"),
          class: "cell_txt_center",
          overflowTooltip: false,
        },
        // ADD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 end↑

        // 異常区分
        {
          prop: "crdProdExKbnName",
          label: t("resource.checkReceInfo.exceptionKbn"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_center",
          overflowTooltip: false,
        },

        // 入荷済み数
        {
          prop: "crdSizeCheckOkQty",
          label: t("resource.checkReceInfo.crdArrivalCompQty"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_right",
          overflowTooltip: true,
        },
        // ADD 2025/07/01 ZLL 課題_数量·纳期调整機能の追加 start↓
        // 日本入荷NG数の追加
        {
          prop: "jpRcvNgQty",
          label: t("resource.checkReceInfo.JP_RCV_NG_SUM"),
          width: t("widgetSize.tableCommon.width80"),
          class: "cell_txt_right",
          overflowTooltip: false,
        },
        // ADD 2025/07/01 ZLL 課題_数量·纳期调整機能の追加 end↑

        // NG数
        {
          prop: "crdSizeCheckNgQty",
          label: t("resource.checkReceInfo.crdSizeCheckNgQty"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_right",
          overflowTooltip: true,
        },

        // 入荷残
        {
          prop: "crdRemnant",
          label: t("resource.checkReceInfo.crdRemnant"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_right",
          overflowTooltip: true,
        },
        // クローズ済み数
        // {
        //   prop: "crdCloseCompQty",
        //   label: t("resource.checkReceInfo.crdArrivalCloseCompQty"),
        //   width: t("widgetSize.tableCommon.defaultWidth"),
        //   class: "cell_txt_right",
        //   overflowTooltip: false,
        // },

        // クローズ残
        // {
        //   prop: "crdCloseRemnant",
        //   label: t("resource.checkReceInfo.crdCloseRemnant"),
        //   width: t("widgetSize.tableCommon.defaultWidth"),
        //   class: "cell_txt_right",
        //   overflowTooltip: false,
        // },
      ],

      //現在選択されているセル
      currentCell: [],
    };
  },

  props: {
    isAdd: {
      Type: Boolean,
      default: false,
    },

    tableData: {
      Type: Object,
      default: null,
    },

    ReceInfoEditForm: {
      Type: Object,
    },

    ReceOrderDialogForm: {
      Type: Object,
    },

    // ADD 2025/12/08 ZLL 課題_251208顧客からの改善したい点への対応 start↓
    SupplierList: {
      Type: Object,
    },
    // ADD 2025/12/08 ZLL 課題_251208顧客からの改善したい点への対応 end↑
  },
  mounted() {
    //テーブルの高さを監視する
    window.addEventListener("resize", this.handleResize);

    // 列幅に自動調整
    setColumnWidth(this.columns, this.orderProductForm);

    // 初期化
    this.init();
  },

  watch: {
    // 注文日
    "receInfoEditForm.quoteDateRange"(value) {
      // 注文日処理
      this.editDate(value);
    },
  },

  computed: {
    ReceOrderDialogFormData() {
      return this.ReceOrderDialogForm;
    },
  },

  methods: {
    // 初期化
    init() {
      // 仕入先Code: 仕入先名
      this.receInfoEditForm.crbSupInfo = this.ReceInfoEditForm.crbSupInfo;

      // 仕入先コード
      this.receInfoEditForm.crbSupCode = this.ReceInfoEditForm.crbSupCode;

      // 入荷No
      this.receInfoEditForm.crdReceNo = this.ReceInfoEditForm.crbReceNo;

      // 注文日→仕入先納期
      this.receInfoEditForm.quoteDateRange =
        this.ReceOrderDialogForm.quoteDateRange;

      // 注文日開始日→仕入先納期開始日
      this.receInfoEditForm.startDate = this.ReceOrderDialogForm.startDate;

      // 注文日終了日→仕入先納期終了日
      this.receInfoEditForm.endDate = this.ReceOrderDialogForm.endDate;

      // ADD 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 start↓
      // 打合データの場合、打合中有が選択を設定
      if (!!this.tableData && this.tableData.length > 0) {
        let aodDiscussExist = this.tableData.some(
          (item) =>
            item.aodDiscussStatus === STR_ONE ||
            item.aodDiscussStatus === "打合中"
        );
        this.discussingFlg = aodDiscussExist;
      }
      // ADD 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 end↑

      if (!this.receInfoEditForm.quoteDateRange) {
        // 日付初期化
        this.dateInit();
      }

      // 検索
      this.searchClick();
    },

    // 选中的行数据
    handleRowClick(row) {
      this.currentCell = row;
    },

    //テーブルの高さを設定する
    handleResize() {
      // UPD 2025/06/13 ZLL 課題_250610顧客からの改善したい点への対応 start↓
      // 課題_打合状態の追加
      // this.detailHeight = getDialogContentHeight(
      //   window.innerHeight,
      //   DIALOG_LINE_HEIGHT * 1,
      //   DIALOG_LINE_HEIGHT * 1,
      //   30
      // );
      this.detailHeight = getDialogContentHeight(
        window.innerHeight,
        DIALOG_LINE_HEIGHT * 2,
        DIALOG_LINE_HEIGHT * 1,
        35
      );
      // UPD 2025/06/13 ZLL 課題_250610顧客からの改善したい点への対応 end↑

      this.colArr = getEditColWidthArr(window.innerWidth, 5);
    },

    //确定ボタン
    confirmClick() {
      this.loading = true;

      // フォーカス削除
      this.$refs.confirmBtn.$el.blur();

      if (this.currentCell.length >= 1) {
        let currentCell = JSON.parse(JSON.stringify(this.currentCell));

        // 注文No
        this.receInfoEditForm.orderNo = this.receInfoEditForm.orderNo?.trim();

        // 図番
        this.receInfoEditForm.aodProdDrawNo =
          this.receInfoEditForm.aodProdDrawNo?.trim();

        getReceOrderSelectInfo(this.receInfoEditForm)
          .then((res) => {
            let data = [];
            let selectedElements = {};

            currentCell.forEach((row) => {
              const key = `${row.crdOrderNo}-${row.crdDetailNo}-${row.crdProdExKbn}`;
              selectedElements[key] = true;
            });

            res.forEach((element, index) => {
              const key = `${element.crdOrderNo}-${element.crdDetailNo}-${element.crdProdExKbn}`;

              // console.log(key);
              if (selectedElements[key]) {
                // 加工单价
                element.odUPrice = formatStringToCurrency(element.odUPrice);
                // 直接添加到 data 中，保持 res 的原始顺序
                data.push(element);
              }
            });

            // currentCell.forEach((row) => {
            //   for (let index = 0; index < res.length; index++) {
            //     const element = res[index];

            //     // 加工単価
            //     element.odUPrice = formatStringToCurrency(element.odUPrice);

            //     //詳細画面選択のデータ選択チェックボックス
            //     if (
            //       row.crdQuoteNo == element.crdQuoteNo &&
            //       row.crdProdNo == element.crdProdNo &&
            //       row.crdProdExKbn == element.crdProdExKbn
            //     ) {
            //       data.push(element);
            //     }
            //   }
            // });

            let result = {
              CurrentCell: data,
              ReceOrderDialogForm: this.receInfoEditForm,
            };

            // console.log(result);

            this.$emit("ok", result);
          })
          .catch((err) => {
            if (err.data != null) {
              Message.showError(
                t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
              );
            } else {
              Message.showError(t("message.COMMON_MESSAGE.SEARCH_FAILURE"));
            }
          })
          .finally(() => {
            this.loading = false;

            // 列幅に自動調整
            setColumnWidth(this.columns, this.orderProductForm);
          });
      } else {
        Modal.showWarning("", t("message.COMMON_MESSAGE.PLEASE_SELECT_DATA"))
          .then(() => {})
          .catch(() => {})
          .finally(() => {
            // フォーカス削除
            this.$refs.confirmBtn.$el.blur();

            this.loading = false;
          });
      }
    },

    // 詳細画面選択のデータ選択チェックボックス
    checkedProcess(modelData) {
      if (modelData) {
        modelData.forEach((row) => {
          for (let index = 0; index < this.orderProductForm.length; index++) {
            const element = this.orderProductForm[index];

            // 加工単価
            element.odUPrice = formatStringToCurrency(element.odUPrice);

            //詳細画面選択のデータ選択チェックボックス
            if (
              row.crdOrderNo == element.crdOrderNo &&
              row.crdDetailNo == element.crdDetailNo &&
              row.crdProdExKbn == element.crdProdExKbn
            ) {
              this.$nextTick(() => {
                this.$refs.orderProductForm.toggleRowSelection(
                  this.orderProductForm[index],
                  true
                );
              });
            }
          }
        });
      }
    },

    // ダイアログを閉じる
    close() {
      this.$emit("cancel");
    },

    // 検索
    searchClick() {
      // 注文No
      this.receInfoEditForm.orderNo = this.receInfoEditForm.orderNo?.trim();

      // 図番
      this.receInfoEditForm.aodProdDrawNo =
        this.receInfoEditForm.aodProdDrawNo?.trim();

      // ADD 2025/06/13 ZLL 課題_250610顧客からの改善したい点への対応 start↓
      // 課題_検査室入荷日の追加
      // 打合中有
      this.receInfoEditForm.searchDiscussingFlg = this.discussingFlg;
      // ADD 2025/06/13 ZLL 課題_250610顧客からの改善したい点への対応 end↑

      getReceOrderSelectInfo(this.receInfoEditForm)
        .then((res) => {
          this.orderProductForm = res;

          // データの変換処理
          this.dataProcess();

          // 詳細画面選択のデータ選択チェックボックス
          this.checkedProcess(this.tableData);

          Message.showSuccess(t("message.COMMON_MESSAGE.SEARCH_SUCCESS"));
        })
        .catch((err) => {
          if (err.data != null) {
            Message.showError(
              t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
            );
          } else {
            Message.showError(t("message.COMMON_MESSAGE.SEARCH_FAILURE"));
          }
        })
        .finally(() => {
          this.loading = false;

          // 列幅に自動調整
          setColumnWidth(this.columns, this.orderProductForm);
        });

      // フォーカス削除
      this.$refs.searchBtn.$el.blur();
    },

    // 注文日処理→仕入先納期処理
    editDate(value) {
      if (Array.isArray(value) && value.length >= 2) {
        //注文日開始日→仕入先納期開始日
        this.receInfoEditForm.startDate = value[0];
        // 注文日終了日→仕入先納期終了日
        this.receInfoEditForm.endDate = value[1];
      } else {
        // 注文日開始日→仕入先納期開始日
        this.receInfoEditForm.startDate = null;
        // 注文日終了日→仕入先納期終了日
        this.receInfoEditForm.endDate = null;
      }
    },

    // オプションCheck
    selectableCheck(row, index) {
      // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
      // 課題_運送状態を削除
      // if (row.crdTransStatus != FINAL_STR.TRD_TRANS_STATUS_NO_TRANS) {
      //   return false;
      // } else {
      // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
      return true;
      // }
    },

    // データの変換処理
    dataProcess() {
      this.orderProductForm.map((item) => {
        // 加工単価
        item.odUPrice = formatStringToCurrency(item.odUPrice);
        // ADD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 start↓
        // 課題_納期分割機能の追加
        item.crdProdExKbnName = ShowMergeExKbn(
          item.crdProdExKbn,
          item.odProdReceExKbn
        );
        // ADD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 end↑

        return item;
      });
    },

    /**
     * el-table-column 自适应列宽
     * @param prop_label: 表名
     * @param table_data: 表格数据
     */
    flexColumnWidthFunc(label, prop) {
      return flexColumnWidth(label, prop, this.orderProductForm);
    },

    // 日付初期化
    dateInit() {
      var systemDate = new Date();
      // UPD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 start↓
      //手配日→仕入先納期列を変更
      // //注文日(終了日)
      // this.receInfoEditForm.endDate = formatDateToString(systemDate);

      // //注文日(開始日)
      // this.receInfoEditForm.startDate = formatDateToString(
      //   getPreviousMonthDate(systemDate)
      // );
      // 仕入先納期(終了日)
      this.receInfoEditForm.endDate = formatDateToString(
        getNextMonthDate(systemDate)
      );

      // 仕入先納期(開始日)
      this.receInfoEditForm.startDate = formatDateToString(systemDate);
      // UPD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 end↑

      //運送明細テーブル注文日→仕入先納期
      for (let index = 0; index < this.tableData.length; index++) {
        const element = this.tableData[index];

        // UPD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 start↓
        // 課題_納期分割機能の追加
        //手配日→仕入先納期列を変更
        // if (
        //   formatStringToDate(element.obDate) >
        //   formatStringToDate(this.receInfoEditForm.endDate)
        // ) {
        //   this.receInfoEditForm.endDate = element.obDate;
        // }

        // if (
        //   formatStringToDate(element.obDate) <
        //   formatStringToDate(this.receInfoEditForm.startDate)
        // ) {
        //   this.receInfoEditForm.startDate = element.obDate;
        // }

        // 仕入先納期列
        if (
          formatStringToDate(element.odDueDate) >
          formatStringToDate(this.receInfoEditForm.endDate)
        ) {
          this.receInfoEditForm.endDate = element.odDueDate;
        }

        if (
          formatStringToDate(element.odDueDate) <
          formatStringToDate(this.receInfoEditForm.startDate)
        ) {
          this.receInfoEditForm.startDate = element.odDueDate;
        }
        // UPD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 end↑
      }

      this.receInfoEditForm.quoteDateRange = [
        this.receInfoEditForm.startDate,
        this.receInfoEditForm.endDate,
      ];
    },

    // 製品異常
    rowClassName({ row, rowIndex }) {
      if (row.crdProdExKbnName != FINAL_STR.PROD_EX_GENERAL_STR) {
        return "textColor";
      }
    },

    // ADD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
    // 課題_備考機能の追加
    //備考表示用
    formatRemarksShowProc(value) {
      return formatRemarksShow(value);
    },

    getIconTypeProc(value) {
      return getIconType(value);
    },

    // ADD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
    // ADD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 start↓
    // 共通備考の調整（備考列幅の設定）
    getRemarksColumnWidthProc() {
      return getRemarksColumnWidth(this.orderProductForm);
    },
    // ADD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 end↑
  },
};
</script>
<style scoped>
.el-form-item__label.custom-label {
  width: 20%;
}

.left-align {
  justify-content: left !important;
}
</style>
